<div [ngClass]="isDrawerOpen? '' : 'noShadowOverlay'" [style.margin.px]="10" [style.overflow-y]="'auto'"
     class="dx-card backgroundCard absoluteFill">
  <dx-drawer
    #drawerComponent
    (onInitialized)="subscribeToWindowResize()"
    (openedChange)="resetDrawerVariables($event)"
    [(opened)]="isDrawerOpen"
    [className]="'drawerParent alarm-detail-container'"
    [closeOnOutsideClick]="false"
    [height]="'100%'"
    [openedStateMode]="appService.isSmallScreen()? 'overlap' : 'shrink'"
    [position]="'right'"
    [revealMode]="'expand'"
    template="template">
    <div *dxTemplate="let data of 'template'"
         [style.background-color]="getStylizedCSSVariable('--dx-component-color-bg')"
         [style.height.%]="100" [style.width.px]="setWidthOfDrawerPx()"
         style="display: flex; flex-direction: column">
      <div *ngIf="!!selectedItem" [style.width.px]="setWidthOfDrawerPx()" class="drawerTitleWrapper">
        <div>
          <h2>{{ "DIAGNOSTIC.METRIC_DETAIL" | translate }}
            {{ selectedOriginEntity === AlarmOriginEntityEnum.GATEWAY ? ("DIAGNOSTIC.GATEWAY" | translate) : ("DIAGNOSTIC.DEVICE" | translate) }}
            {{ selectedItem.name }}</h2>
          <h2 class="itemName"></h2>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
          <app-alarm-time-selector
            (onTimeSettingChange)="reloadDiagnosticEvents()"
            [(endDate)]="endDate"
            [(lastEventsNumber)]="lastEventsNumber"
            [(realTimeUnit)]="realTimeUnit"
            [(realtimeValue)]="realtimeValue"
            [(startDate)]="startDate"
            [(typeOfDateSettings)]="typeOfDateSettings">
          </app-alarm-time-selector>
          <dx-button (onClick)="drawerComponent.instance.hide()" [type]="'default'" [width]="30"
                     icon="close"></dx-button>
        </div>
      </div>
      <div *ngIf="!!selectedItem" class="metricContainer flexFill">

        <div class="flexColumn" style="gap: 3px">
          <span [innerHTML]="getCurrentItemStatus()" class="statusInfo"></span>
          <span *ngIf="selectedOriginEntity === AlarmOriginEntityEnum.GATEWAY"
                [innerHtml]="getSelectedGatewayStatus()"
                class="statusInfo"></span>
        </div>

        <dx-data-grid
          style="min-height: 350px;"
          [columnAutoWidth]="true"
          [dataSource]="selectedItemEvents"
          [height]="'100%'"
          [showBorders]="true"
          [showRowLines]="false">
          <dxo-pager [showPageSizeSelector]="true" [visible]="true"></dxo-pager>
          <dxo-header-filter [visible]="true"></dxo-header-filter>
          <dxi-column
            caption="{{ 'DIAGNOSTIC.TS' | translate }}"
            dataField="ts" dataType="datetime">
            <dxo-format
              [formatter]="parseDateFromObject">
            </dxo-format>
          </dxi-column>
          <dxi-column caption="{{ 'DIAGNOSTIC.ALARM_STATUS' | translate }}" dataField="alarmStatus"></dxi-column>
          <dxi-column *ngIf="selectedOriginEntity !== AlarmOriginEntityEnum.GATEWAY" [allowHeaderFiltering]="false"
                      caption="{{ 'DIAGNOSTIC.MESSAGE' | translate }}" dataField="message"></dxi-column>
        </dx-data-grid>
      </div>
    </div>
    <div class="flexColumn" style="height: 100%; width: 100%;">
      <div [ngClass]="isMobile? 'flexColumn' : 'flexRow'" class="filterHeader">
        <div class="flexRow flexFill" style="min-width:min-content; gap: 20px; flex-wrap: wrap;">
          <div class="flexRow">
            <span>{{ "DIAGNOSTIC.GATEWAY" | translate }}</span>
            <dx-button (onClick)="filterGateway(0)" [elementAttr]="{class: 'ok'}" [height]="25"
                       [ngClass]="gatewayFilters.includes(0)? 'selected' : 'deselected'"
                       stylingMode="contained" type="default">
              <span>{{ 'DIAGNOSTIC.ONLINE' | translate }}</span>
            </dx-button>
            <dx-button (onClick)="filterGateway(1)" [elementAttr]="{class: 'offline'}" [height]="25"
                       [ngClass]="gatewayFilters.includes(1)? 'selected' : 'deselected'"
                       stylingMode="contained" type="default">
              <span>{{ 'DIAGNOSTIC.OFFLINE' | translate }}</span>
            </dx-button>
          </div>
          <div class="flexRow">
            <span>{{ "DIAGNOSTIC.DEVICE" | translate }}</span>
            <dx-button (onClick)="filterDevice(0)" [elementAttr]="{class: 'ok'}" [height]="25"
                       [ngClass]="deviceFilters.includes(0)? 'selected' : 'deselected'"
                       stylingMode="contained" type="default">
              <span>{{ 'DIAGNOSTIC.ONLINE' | translate }}</span>
            </dx-button>
            <dx-button (onClick)="filterDevice(2)" [elementAttr]="{class: 'warning'}" [height]="25"
                       [ngClass]="deviceFilters.includes(2)? 'selected' : 'deselected'"
                       stylingMode="contained" type="default">
              <span>{{ 'DIAGNOSTIC.WARNING' | translate }}</span>
            </dx-button>
            <dx-button (onClick)="filterDevice(1)" [elementAttr]="{class: 'offline'}" [height]="25"
                       [ngClass]="deviceFilters.includes(1)? 'selected' : 'deselected'"
                       stylingMode="contained" type="default">
              <span>{{ 'DIAGNOSTIC.OFFLINE' | translate }}</span>
            </dx-button>
            <dx-button (onClick)="collapsedTags = !collapsedTags" [height]="25"
                       hint="{{ (collapsedTags? 'DIAGNOSTIC.FULL_ICONS' : 'DIAGNOSTIC.SMALL_ICONS') | translate}}"
                       stylingMode="text">
              <i *ngIf="!collapsedTags" class="vr-ic_fluent_arrow_minimize_24_regular"></i>
              <i *ngIf="collapsedTags" class="vr-ic_fluent_arrow_maximize_24_regular"></i>
            </dx-button>
          </div>
          <div class="flexFill flexRow" style="align-items: flex-start;">
            <dx-text-box
              [(value)]="searchInput"
              [width]="'100%'"
              mode="search">
            </dx-text-box>
            <dx-button
              (onClick)="loadDiagnosticStatus()"
              [icon]="'refresh'"
              stylingMode="text">
            </dx-button>
          </div>
        </div>
      </div>
      <dx-scroll-view style="height: 100%; width: 100%;">

        <div *ngIf="partitionSelection.selectedPartitionId === undefined || partitionSelection.selectedPartitionId === null"
             class="unselectable absoluteFill flexCenter">
          <h3>{{ "DIAGNOSTICS.SELECT_PARTITION" | translate }}</h3>
        </div>

        <div *ngIf="!!partitionSelection.selectedPartitionId || partitionSelection.selectedPartitionId === 0"
             class="alarmContainer fullWidth">
          <div *ngFor="let partition of partitionAlarms"
               [ngClass]="selectedItemPartitionId === partition.id? 'selected' : ''"
               class="dx-card alarmPartitionContainer">
            <span class="alarmPartitionName unselectable">{{ partition.path }}</span>
            <div *ngIf="!!partition.gateways && partition.gateways.length > 0" class="alarmContainer gateway">
              <ng-container *ngFor="let gateway of partition.gateways">
                <div (click)="openGatewayDetail(partition, gateway)"
                     *ngIf="gatewayFilters.includes(gateway.alarmStatus)"
                     [ngClass]="getAlarmStatusCssClass(gateway)" class="dx-card alarmCard gateway">
                  <span class="alarmGatewayName unselectable">{{ gateway.name }}</span>
                  <div
                    *ngIf="getBySearch(gateway.devices).length > 0 && getByFilters(gateway.devices, deviceFilters).length > 0"
                    class="alarmContainer device">
                    <ng-container *ngFor="let device of getBySearch(gateway.devices)">
                      <div (click)="openDeviceDetail(partition, device); $event.stopPropagation()"
                           *ngIf="deviceFilters.includes(device.alarmStatus)"
                           [ngClass]="getAlarmStatusCssClass(device)" [style.border-radius]="collapsedTags? '50%' : ''"
                           class="dx-card alarmCard device">
                        <span *ngIf="!collapsedTags" class="alarmDeviceName unselectable">{{ device.name }}</span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </dx-scroll-view>
    </div>
  </dx-drawer>
</div>
